import {
  deleteBalancesCache,
  type RecoverMpcFundsRequest,
  recoverAutopilotFunds,
} from '@polaris/core/services'
import { runnerSessionDataAtom } from '@polaris/core/stores/mpc/atom'
import { useMutation } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import {
  type ParsedMpcError,
  parseMpcError,
} from '@/src/utils/parse-mpc-errors'

export const useMpcRecoverFunds = () => {
  const mpcSessionData = useAtomValue(runnerSessionDataAtom)

  return useMutation<
    void,
    ParsedMpcError,
    Omit<RecoverMpcFundsRequest, 'sessionKeyData'> & {
      fromAddress?: string
    }
  >({
    mutationKey: ['mpc-recover-funds'],
    mutationFn: async (
      payload: Omit<RecoverMpcFundsRequest, 'sessionKeyData'> & {
        fromAddress?: string
      },
    ) => {
      try {
        await recoverAutopilotFunds({
          ...payload,
          sessionKeyData: {
            walletSig: mpcSessionData!.authSig,
            sessionKeyPair: mpcSessionData!.sessionKeyPair,
          },
        })
      } catch (error) {
        throw parseMpcError(error)
      }
    },
    onSuccess(_, variables) {
      const addressChainIdSet = [
        {
          chain_id: variables.chainID,
          address: variables.toAddress,
        },
      ]

      if (variables.fromAddress) {
        addressChainIdSet.push({
          chain_id: variables.chainID,
          address: variables.fromAddress,
        })
      }

      deleteBalancesCache({
        addressChainIdSet,
      })
    },
  })
}
